export const setSelectedAudioDevice = (deviceId) => ({
  type: "CHANGE_AUDIO_DEVICE",
  payload: { deviceId },
});

export const setSelectedAudioOutputDevice = (deviceId) => ({
  type: "CHANGE_AUDIO_OUTPUT_DEVICE",
  payload: { deviceId },
});

export const setSelectedWebcamDevice = (deviceId) => ({
  type: "CHANGE_WEBCAM",
  payload: { deviceId },
});

export const setVideoResolution = (resolution) => ({
  type: "SET_VIDEO_RESOLUTION",
  payload: { resolution },
});

export const setDisplayName = (displayName) => ({
  type: "SET_DISPLAY_NAME",
  payload: { displayName },
});

export const toggleAdvancedMode = () => ({
  type: "TOGGLE_ADVANCED_MODE",
});

export const togglePermanentTopBar = () => ({
  type: "TOGGLE_PERMANENT_TOPBAR",
});

export const setLastN = (lastN) => ({
  type: "SET_LAST_N",
  payload: { lastN },
});

export const setSoundNotificationsDisabled = (soundNotificationsDisabled) => ({
  type: "SET_SOUND_NOTIFICATIONS_DISABLED",
  payload: { soundNotificationsDisabled },
});

export const toggleDarkMode = () => ({
  type: "TOGGLE_DARK_MODE",
});

export const setAppBrand = (brand) => ({
  type: "SET_APP_BRAND",
  payload: brand || {},
});
